import { Cassette } from '../../domain/cassette';
import { PlageHoraire } from '../../domain/plage-horaire';
import { Pompe } from '../../domain/pompe';
import { mapper } from '../../tools/mapping/mapper';
import { CassetteEntity, PompeEntity, PlageHoraireEntity } from '../entity';
import type { AppDB } from '../db';

export class CassetteRepository {
    constructor(private readonly database: AppDB) {}


    async getCassetteEntityById(id: number) {
        return await this.database.cassettes.where('Id').equals(id).first(async ze => {
            return ze;
        });
    }

    async getCassetteByIdWithChildren(id: number) {
        return await this.database.cassettes.where('Id').equals(id).first(async ce => {
            const c = mapper.map(ce, CassetteEntity, Cassette);
            if (ce?.PlageHoraireIds) {
                c.PlageHoraireList = await Promise.all(
                    await this.database.plageHoraires.where('Id').anyOf(ce?.PlageHoraireIds).toArray(ies => {
                        return ies.map(async ie => {
                            const ph = mapper.map(ie, PlageHoraireEntity, PlageHoraire);
                            return ph;
                        });
                    })
                );
            }
            if (ce?.PompeId) {
                const pe = await this.database.getPompeEntityById(ce.PompeId);
                const p = mapper.map(pe, PompeEntity, Pompe);
                c.Pompe = p;
            }
            return c;
        });
    }

    async attachCassette(cassette: Cassette, measureId: number) {
        let cassetteId: number;
        const ce = mapper.map(cassette, Cassette, CassetteEntity);

        cassetteId = await this.database.cassettes.add(ce);
        await this.database.mesures.update(measureId, {
            CassetteId: cassetteId
        });

        if (cassette.Pompe) {
            this.database.attachPompe(cassette.Pompe, cassetteId);
        }

        if (cassette?.PlageHoraireList.length > 0) {
            for (let i = 0; i < cassette.PlageHoraireList.length; i++) {
                await this.database.attachPlageHoraire(cassette.PlageHoraireList[i], cassetteId);
            }
        }
        return cassetteId;
    }

    async attachCassetteToOperator(cassette: Cassette, operatorId: number) {
        let cassetteId: number;
        const ce = mapper.map(cassette, Cassette, CassetteEntity);

        const oe = await this.database.getOperatorEntityById(operatorId);
        cassetteId = await this.database.cassettes.add(ce);
        await this.database.operators.update(operatorId, {
            CassetteIds: oe?.CassetteIds ? [...oe.CassetteIds, cassetteId] : [cassetteId]
        });

        if (cassette.Pompe) {
            this.database.attachPompe(cassette.Pompe, cassetteId);
        }

        if (cassette?.PlageHoraireList.length > 0) {
            for (let i = 0; i < cassette.PlageHoraireList.length; i++) {
                await this.database.attachPlageHoraire(cassette.PlageHoraireList[i], cassetteId);
            }
        }
        return cassetteId;
    }
}
